import { Box, Flex, styled } from '@grupoboticario/flora-react';

const styles = {
  CardInfo: styled(Flex, {
    backgroundColor: '$backgroundTertiary',
    borderRadius: '$small',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '$6 0 $6 0',
    gap: '$1',
    padding: '$6',
    width: '100%',

    '@tablet': {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'flex-start',
    },
  }),

  InfoIcon: styled(Box, {
    margin: '$1 $2 $0 $0',
  }),
};

export default styles;
